// @flow

import stores from 'stores';

export default (orgId: string, login: string) => {
  return stores.usersStore.suspendUser(orgId, login);
};
